const getPubType = (data): string => {
  if (!data.pubtype) {
    return ''
  }
  if (!('main' in data.pubtype)) {
    if ('suffix' in data.pubtype) {
      return data.pubtype.suffix
    }

    return ''
  }

  return data.pubtype.main
}

const getFromPub = (data, name: string): string => {
  const pubtype = getPubType(data)
  if (pubtype && data[pubtype]) {
    if (name in data[pubtype]) {
      return data[pubtype][name]
    }
  }
}

export const getSummaryTitle = (data): string => {
  // eslint-disable-next-line default-case
  switch (data.source) {
    case 'thesis':
    case 'journal':
    case 'dissertation':
    case 'chapter':
    case 'newspaper':
    case 'website':
    case 'fedbill':
    case 'mailinglist':
    case 'email':
    case 'testimony':
    case 'film':
    case 'letter':
    case 'patent':
    case 'software':
    case 'courtcase':
    case 'statute':
    case 'map':
    case 'painting':
    case 'magazine':
    case 'musicalrecording':
      if (data.source && data.source in data && data[data.source].title) {
        return data[data.source].title
      }
      break
    case 'rawdata':
      if (data.rawdata) {
        return data.rawdata.desc
      }
      break
    case 'conference':
      if (data.conference) {
        return data.conference.title2
      }
      break
  }

  return getFromPub(data, 'title')
}
